import { Container, Grid } from "@material-ui/core";
import { Box, Button, Stack, createTheme, useMediaQuery } from "@mui/material";
import React from "react";
import "../../index.css";
import Typography from "@mui/material/Typography";
import HeroImg2 from "../../../src/asset/internationalRelationTemp/studentRecHero2.png";
import Header from "../content-component/Header";
import HeroImg1 from "../../../src/asset/internationalRelationTemp/studentRecHero.png";
import "../../globle.css";
import ParaData from "../content-component/ParaData";

const StudentRecruitment = () => {
  const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const largeScreen = createTheme({
    breakpoints: {
      values: {
        lg: 1024,
        xxl: 1920,
      },
    },
  });

  const isLargeScreen = useMediaQuery(largeScreen.breakpoints.up("xxl"));
  const mediumLarge = useMediaQuery(largeScreen.breakpoints.up("lg"));


  const handleClick = (path) => {
    window.location.href = path;
  }

  return (
    <Container
      id="international-student-recruitment"
      maxWidth={isLargeScreen ? "xl" : "lg"}
    >
      <Grid
        container
        spacing={isSmScreen ? 4 : isMediumScreen ? 4 : mediumLarge ? 4 : 8}
        display="flex"
        justifyContent="space-between"
        style={{
          height: "100%",
          padding: "50px 0",
        }}
      >
       <Grid item xs={12} sm={6} md={7} lg={7} textAlign="center">
  <Typography
    variant="h2"
    gutterBottom
    sx={{
      color: "#00999E",
      fontSize: "36px",
      fontStyle: "normal",
      mt: 6,
      fontWeight: 600,
      lineHeight: { xs: "50px", sm: "50px", md: "80px", lg: "100px" },
      textTransform: "capitalize",
    }}
  >
    <Header content="International Student Recruitment"></Header>
  </Typography>
  <ParaData
    color={"#525560"}
    fontSize={"16px"}
    content={
      <>
        India is a top study destination with <b>1,100+ universities</b> and{" "}
        <b>42,000+ colleges</b>, attracting <b>50,000+ international students</b> from{" "}
        <b>160+ countries</b>. Prestigious institutions like <b>IITs, IIMs, and AIIMS</b>{" "}
        offer world-class education at <b>affordable costs</b>—tuition starts at{" "}
        <b>$1,000/year</b>, and living expenses average from <b>$800/year to $1,500/year</b>.
        With a booming economy and industry ties, India offers excellent{" "}
        <b>career opportunities</b> and global exposure.
      </>
    }
  />

  {/* Button Centered */}
  <Box display="flex" justifyContent="start" alignItems="center" width="100%">
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#00999E",
        color: "#fff",
        padding: "10px 20px",
        fontSize: "16px",
        fontWeight: "bold",
        textTransform: "capitalize",
        borderRadius: "8px",
        marginTop: "50px",
        "&:hover": {
          backgroundColor: "#007F85",
        },
      }}
      onClick={() => handleClick('/international-relation/india')}
    >

        For More Details on Indian Universities →
    </Button>
  </Box>
</Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          lg={5}
          sx={{
            width: "100%",
            margin: "auto",
          }}
        >
          <Stack
            style={{
              width: "100%",
              height: "480px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            <Stack
              sx={{
                width: isSmScreen ? "85%" : isMediumScreen ? "90%" : "400px",
                background: "#00999E",
                height: isSmScreen ? "85%" : isMediumScreen ? "85%" : "360px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
                borderRadius: "10px 0px 10px 0px",
                "@media screen and (min-width: 1024px) and (max-width: 1024px)":
                  {
                    width: "350px !important",
                  },
              }}
            >
              <img
                src={HeroImg1}
                alt="heroImg1"
                loading="lazy"
                style={{
                  width: isSmScreen
                    ? "80%"
                    : isMediumScreen
                    ? "70%"
                    : mediumLarge
                    ? "60%"
                    : largeScreen
                    ? "50%"
                    : "60%",
                  height: isSmScreen
                    ? "45%"
                    : isMediumScreen
                    ? "45%"
                    : largeScreen
                    ? "47%"
                    : "47%",
                  position: "absolute",
                  top: 0,
                  right: 0,
                  borderRadius: "10px",
                }}
              />
              <img
                src={HeroImg2}
                alt="heroImg2"
                loading="lazy"
                style={{
                  width: isSmScreen
                    ? "80%"
                    : isMediumScreen
                    ? "70%"
                    : mediumLarge
                    ? "60%"
                    : largeScreen
                    ? "50%"
                    : "60%",
                  height: isSmScreen
                    ? "45%"
                    : isMediumScreen
                    ? "45%"
                    : largeScreen
                    ? "47%"
                    : "47%",
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  borderRadius: "10px",
                }}
              />
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};

export default StudentRecruitment;
